import Vue from 'vue'
import Router from 'vue-router'
import * as auth from '@/libs/auth0';
import Home from '@/pages/Home'
import Admin from '@/pages/Admin'
import Login from '@/pages/Login'
import CompanySetup from '@/pages/CompanySetup'
import CompanyEdit from '@/pages/CompanyEdit'
import Start from '@/pages/Start'
import Properties from '@/pages/Properties'
import AddProperty from '@/pages/Properties-Add'
import EditProperty from '@/pages/Properties-Edit'
import Settings from '@/pages/Settings'
import SettingsPortals from '@/pages/Settings-Portals'
import SettingsPortalsRightmove from '@/pages/Settings-Portals-Rightmove'
import SettingsPortalsOnthemarket from '@/pages/Settings-Portals-Onthemarket'
import SettingsPortalsZoopla from '@/pages/Settings-Portals-Zoopla'
import SettingsPortalsCustom from '@/pages/Settings-Portals-Custom'
import SettingsDemoMode from '@/pages/Settings-DemoMode'
import WebsiteEdit from '@/pages/Website-Edit'
import WebsiteSetup from '@/pages/Website-Setup'
import ActivatePortal from '@/pages/ActivatePortal'
import GDPR from '@/pages/GDPR'
import GDPRInfo from '@/pages/GDPRInfo'
import GDPRRemove from '@/pages/GDPRRemove'
import Owners from '@/pages/Owners'
import EditOwner from '@/pages/Owners-Edit'
import OwnerReg from '@/pages/Owner-Reg'
import OwnerConfirm from '@/pages/Owner-Confirm'
import Applicants from '@/pages/Applicants'
import EditApplicant from '@/pages/Applicants-Edit'
import ApplicantReg from '@/pages/Applicant-Reg'
import ApplicantUpdate from '@/pages/Applicant-Update'
import ApplicantConfirm from '@/pages/Applicant-Confirm'
import ConditionsOfUse from '@/pages/ConditionsOfUse'
import ConditionsAccepted from '@/pages/ConditionsOfUse-Accepted'
import BillingPanel from '@/pages/BillingPanel'
import Marketplace from '@/pages/Marketplace'
import Supplier from '@/pages/Supplier'
import Offer from '@/pages/Offer'
import SupplierBATrigger from '@/pages/Supplier-BA-Trigger'
import SupplierBAAction from '@/pages/Supplier-BA-Action'
import SettingsApplicantImport from '@/pages/Settings-Applicant-Import'
import SettingsRestAPI from '@/pages/Settings-RestAPI'
import SettingsRestAPIAdd from '@/pages/Settings-RestAPI-Add'
import BookingView from '@/pages/BookingView'
import APIKeys from '@/pages/APIKeys'
import Auth0 from '@/pages/Auth0'

Vue.use(Router)


const requireAuth = (to, from, next) => {
  auth.requireAuth(to, from, next);
};

const requireAdmin = (to, from, next) => {
  auth.requireAdmin(to, from, next);
};

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/login',
			name: 'Login',
			redirect: '/',
		},
		{
			path: '/new-user',
			name: 'NewUser',
			component: Home,
			beforeEnter: requireAuth
		},
		{
			path: '/activate-account/:username/:code',
			name: 'ActivateAccount',
			redirect: '/',
		},
		{
			path: '/reset-password/:username/:code',
			name: 'ResetPassword',
			redirect: '/',
		},
		{
			path: '/',
			name: 'Home',
			component: Home,
			beforeEnter: requireAuth
		},
		{
			path: '/auth0',
			name: 'Auth0',
			component: Auth0,
		},
		{
			path: '/admin',
			name: 'Admin',
			component: Admin,
			beforeEnter: requireAdmin
		},
		{
			path: '/company-setup',
			name: 'CompanySetup',
			component: CompanySetup,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/company',
			name: 'CompanyEdit',
			component: CompanyEdit,
			beforeEnter: requireAuth
		},
		{
			path: '/start',
			name: 'Start',
			component: Start,
			beforeEnter: requireAuth
		},
		{
			path: '/welcome',
			name: 'Welcome',
			component: Start,
			beforeEnter: requireAuth
		},
		{
			path: '/properties',
			name: 'Properties',
			component: Properties,
			beforeEnter: requireAuth
		},
		{
			path: '/properties/add',
			name: 'AddProperty',
			component: AddProperty,
			beforeEnter: requireAuth
		},
		{
			path: '/properties/:id',
			name: 'EditProperty',
			component: EditProperty,
			beforeEnter: requireAuth
		},
		{
			path: '/applicants',
			name: 'Applicants',
			component: Applicants,
			beforeEnter: requireAuth
		},
		{
			path: '/owners',
			name: 'Owners',
			component: Owners,
			beforeEnter: requireAuth
		},
		{
			path: '/applicants/:id',
			name: 'EditApplicant',
			component: EditApplicant,
			beforeEnter: requireAuth
		},
		{
			path: '/owners/:id',
			name: 'EditOwner',
			component: EditOwner,
			beforeEnter: requireAuth
		},
		{
			path: '/settings',
			name: 'Settings',
			component: Settings,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/applicant-import',
			name: 'SettingsApplicantImport',
			component: SettingsApplicantImport,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals',
			name: 'SettingsPortals',
			component: SettingsPortals,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/rightmove',
			name: 'SettingsPortalsRightmove',
			component: SettingsPortalsRightmove,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/onthemarket',
			name: 'SettingsPortalsOnthemarket',
			component: SettingsPortalsOnthemarket,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/zoopla',
			name: 'SettingsPortalsZoopla',
			component: SettingsPortalsZoopla,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/custom',
			name: 'SettingsPortalsCustom',
			component: SettingsPortalsCustom,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/custom/:id',
			name: 'SettingsPortalsCustomId',
			component: SettingsPortalsCustom,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/website',
			name: 'SettingsPortalsWebsite',
			component: SettingsPortalsCustom,
			props: { website: true },
			beforeEnter: requireAuth
		},
		{
			path: '/settings/portals/website/:id',
			name: 'SettingsWebsiteId',
			component: SettingsPortalsCustom,
			props: { website: true },
			beforeEnter: requireAuth
		},
		{
			path: '/activate-:portal/:id',
			name: 'ActivatePortal',
			component: ActivatePortal,
			meta: { bodyClass: 'login__body' }
		},
		{
			path: '/settings/demo-mode',
			name: 'SettingsDemoMode',
			component: SettingsDemoMode,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/website',
			name: 'WebsiteEdit',
			component: WebsiteEdit,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/website-setup',
			name: 'WebsiteSetup',
			component: WebsiteSetup,
			beforeEnter: requireAuth
		},
		{
			path: '/billing-panel',
			name: 'BillingPanel',
			component: BillingPanel,
			beforeEnter: requireAuth,
      meta: { requireStripe: true }
		},
		{
			path: '/marketplace',
			name: 'Marketplace',
			component: Marketplace,
			beforeEnter: requireAuth,
      meta: { requireStripe: true }
		},
		{
			path: '/settings/conditions-of-use',
			name: 'ConditionsOfUse',
			component: ConditionsOfUse
		},
		{
			path: '/conditions-of-use',
			name: 'ConditionsOfUse2',
			component: ConditionsOfUse
		},
		{
			path: '/accept-conditions/:companyId',
			name: 'ConditionsAccepted',
			component: ConditionsAccepted,
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/easymatch/gdpr/yes/:companyId-:contactId',
			name: 'GDPRYes',
			component: GDPR,
			props: { consent: true },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/easymatch/gdpr/no/:companyId-:contactId',
			name: 'GDPRNo',
			component: GDPR,
			props: { consent: false },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/gdpr/no/:companyId/:contactId',
			name: 'GDPRNoBA',
			component: GDPR,
			props: { consent: false, ba: true },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/yes/:companyId-:contactId',
			name: 'GDPRYesShort',
			component: GDPR,
			props: { consent: true, sms: true },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/no/:companyId-:contactId',
			name: 'GDPRNoShort',
			component: GDPR,
			props: { consent: false, sms: true },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/easymatch/gdpr/info/:companyId-:contactId',
			name: 'GDPRInfo',
			component: GDPRInfo,
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/gdpr/info/:companyId/:contactId',
			name: 'GDPRInfoBA',
			component: GDPRInfo,
			props: { ba: true },
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/easymatch/gdpr/remove/:companyId-:contactId',
			name: 'GDPRRemove',
			component: GDPRRemove,
			meta: { noNavBar: true, bodyClass: 'login__body' }
		},
		{
			path: '/auth/linkedin/callback',
			name: '/linkedInCallback',
			component: Login,
			props: { linkedinLoginFlag: true },
			meta: { noNavBar: true }
		},
		{
			path: '/register/linkedin/callback',
			name: 'ApplicantRegLinkedin',
			component: ApplicantReg,
			props: {linkedin: true},
			meta: { noNavBar: true, bodyClass: 'login__body', requireSocials: true, skipMaps: true }
		},
		{
			path: '/register/e/:companyId/:applicantId',
			name: 'ApplicantUpdateEmail',
			component: ApplicantUpdate,
			props: {email: true},
			meta: { noNavBar: true, bodyClass: '' }
		},
		{
			path: '/register/m/:companyId/:applicantId',
			name: 'ApplicantUpdateMobile',
			component: ApplicantUpdate,
			props: {mobile: true},
			meta: { noNavBar: true, bodyClass: '' }
		},
		{
			path: '/register/:companyId/:applicantId',
			name: 'ApplicantUpdate',
			component: ApplicantUpdate,
			props: {},
			meta: { noNavBar: true, bodyClass: '', requireSocials: true }
		},
		{
			path: '/registerowner/linkedin/callback',
			name: 'OwnerRegLinkedin',
			component: OwnerReg,
			props: {linkedin: true},
			meta: { requireSocials: true, skipMaps: false, isReallyAuth: true },
			beforeEnter: requireAuth
		},
		{
			path: '/registerowner/:companyId/:ownerId',
			name: 'OwnerRegEdit',
			component: OwnerReg,
			props: {},
			meta: { requireSocials: true, skipMaps: false, isReallyAuth: true },
			beforeEnter: requireAuth
		},
		{
			path: '/registerowner/:companyId/p/:propertyId',
			name: 'OwnerRegProperty',
			component: OwnerReg,
			props: {},
			meta: { requireSocials: true, skipMaps: false, isReallyAuth: true },
			beforeEnter: requireAuth
		},
		{
			path: '/register-owner/linkedin/callback',
			name: 'OwnerRegPublicLinkedin',
			component: OwnerReg,
			props: {linkedin: true},
			meta: { noNavBar: true, bodyClass: 'login__body', requireSocials: true, skipMaps: true }
		},
		{
			path: '/register-owner/:companyId/:ownerId',
			name: 'OwnerRegEditPublic',
			component: OwnerReg,
			props: {},
			meta: { noNavBar: true, bodyClass: 'login__body', requireSocials: true, skipMaps: false }
		},
		{
			path: '/register-owner/:companyId',
			name: 'OwnerRegPublic',
			component: OwnerReg,
			props: {},
			meta: { noNavBar: true, bodyClass: 'login__body', requireSocials: true, skipMaps: false }
		},
		{
			path: '/registerowner/:companyId',
			name: 'OwnerReg',
			component: OwnerReg,
			props: {},
			meta: { requireSocials: true, skipMaps: false, isReallyAuth: true },
			beforeEnter: requireAuth
		},
		{
			path: '/register/:companyId',
			name: 'ApplicantReg',
			component: ApplicantReg,
			props: {},
			meta: { noNavBar: true, bodyClass: 'login__body', requireSocials: true, skipMaps: true }
		},
		{
			path: '/confirm/e/:companyId/:applicantId',
			name: 'ApplicantConfirmEmail',
			component: ApplicantConfirm,
			props: {email: true},
			meta: { noNavBar: true, bodyClass: '' }
		},
		{
			path: '/confirm/m/:companyId/:applicantId',
			name: 'ApplicantConfirmMobile',
			component: ApplicantConfirm,
			props: {mobile: true},
			meta: { noNavBar: true, bodyClass: '' }
		},
		{
			path: '/confirmowner/m/:companyId/:ownerId',
			name: 'OwnerConfirmMobile',
			component: OwnerConfirm,
			props: {mobile: true},
			meta: { noNavBar: true, bodyClass: '' }
		},
		{
			path: '/supplier',
			name: 'Supplier',
			component: Supplier,
			beforeEnter: requireAuth
		},
		{
			path: '/supplier/trigger',
			name: 'SupplierBATrigger',
			component: SupplierBATrigger,
			beforeEnter: requireAuth
		},
		{
			path: '/supplier/action',
			name: 'SupplierBAAction',
			component: SupplierBAAction,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/rest-api',
			name: 'SettingsRestAPI',
			component: SettingsRestAPI,
			beforeEnter: requireAuth
		},
		{
			path: '/settings/rest-api/add',
			name: 'SettingsRestAPIAdd',
			component: SettingsRestAPIAdd,
			beforeEnter: requireAuth
		},
    // OFFERS
    {
			path: '/offer/:offerId/:userId',
			name: 'Offer',
			component: Offer,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true, isReallyAuth: false }
		},
		{
			path: '/offer/:offerId/:userId/:action',
			name: 'OfferAction',
			component: Offer,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true, isReallyAuth: false }
		},
		{
			path: '/offer/:offerId/:userId/:action/:params',
			name: 'OfferParams',
			component: Offer,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true, isReallyAuth: false }
		},
    // BOOKING
		{
			path: '/booking/:trackId/:userId',
			name: 'BookingView',
			component: BookingView,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true }
		},
		{
			path: '/booking/:trackId/:userId/:action',
			name: 'BookingViewAction',
			component: BookingView,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true }
		},
		{
			path: '/booking/:trackId/:userId/:action/:params',
			name: 'BookingViewParams',
			component: BookingView,
			meta: { noNavBar: true, bodyClass: '', bypassExternals: true }
		},
		{
			path: '/apikeys/:companyId/:token',
			name: 'APIKeys',
			component: APIKeys,
			meta: { noNavBar: true, bodyClass: '' }
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js